/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneDiagIcon20Solid = forwardRef('SendPaperplaneDiagIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M15.364 2.618 2.213 6.678c-.94.29-1.13 1.536-.319 2.092l3.996 2.742c.467.321 1.096.263 1.496-.137l3.55-3.55a.75.75 0 0 1 1.06 1.06l-3.55 3.55c-.4.4-.458 1.03-.138 1.497l2.737 3.989c.556.81 1.802.621 2.092-.318l4.064-13.147c.35-1.128-.708-2.186-1.837-1.838Z" })));
});
